export default __webpack_public_path__ + "static/media/blindness.e3282140.png";